import { h, defineComponent } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { container, pageTitle } from '@/ui/components';
import { secondaryNavbar, TabItem } from '@/ui/components/navigation/SecondaryNavbar';
import { UserProfileTabNames, queryTabName } from '@/ui/components/navigation/constants';
import { ReminderConfigurations } from '@/ui/components/reminderNotification/Configurations';
import * as qs from '@/ui/queryState';
import { General, ChangePassword } from '@/ui/pages/auth/tabs';

export const ProfilePage = defineComponent({
  name: 'ProfilePage',
  setup() {
    const activeTab = qs.stringEnum<UserProfileTabNames>(
      queryTabName,
      Object.values(UserProfileTabNames),
      UserProfileTabNames.GENERAL,
      false,
    );

    const secondaryTabItems : TabItem[] = [
      {
        value: UserProfileTabNames.GENERAL,
        label: t('common.general'),
        icon: 'user',
        underLineColor: 'blue',
      },
      {
        value: UserProfileTabNames.CHANGE_PASSWORD,
        label: t('common.change-password'),
        icon: 'lock',
        underLineColor: 'purple',
      },
      {
        value: UserProfileTabNames.NOTIFICATIONS,
        label: t('common.notifications'),
        icon: 'bell',
        underLineColor: 'green',
      },
    ];

    const getTab = () => {
      switch (activeTab.value) {
        case UserProfileTabNames.GENERAL:
          return General;
        case UserProfileTabNames.CHANGE_PASSWORD:
          return ChangePassword;
        case UserProfileTabNames.NOTIFICATIONS:
          return ReminderConfigurations;
        default:
          throw new Error('Invalid tab selected. Please use UserProfileTabNames enumeration');
      }
    };

    return function render() {
      return container(
        [
          pageTitle(t('profile.your')),

          secondaryNavbar({
            props: { value: activeTab.value, tabItems: secondaryTabItems },
            on: {
              input: (value: UserProfileTabNames) => {
                activeTab.value = value;
              },
            },
          }),
          h(getTab()),
        ],
        'narrow',
      );
    };
  },
});
